import React, { useEffect, useState } from 'react';
import moment from 'moment';
import TrialVoucherForm from './TrialVoucherForm'
import * as Yup from "yup";
import * as actions from './store/trialVoucherActions';
import History from "../../../History";
import { CancelToken } from 'axios';
import { connect } from 'react-redux';
import { snackActions } from '../../sc-utilities/SnackBar';
import { CircularProgress } from '@material-ui/core';

const TrialVoucherCreate = props => {
    const { activeCustomerID, translations, onFetchPlans, onCreateTrialVoucher } = props;
    const [createData, setCreateData] = useState({ plans: [], loadingData: true });

    useEffect(() => {
        const requestToken = CancelToken.source();
        const fetchData = async () => {
            let plans = await onFetchPlans({ ActiveCustomerID: activeCustomerID }, { CancelToken: requestToken.token });
            if (plans instanceof Array && plans.length < 1) {
                snackActions.snackBarComponent("No plans found, cannot select plans.", "info");
            }
            setCreateData({ loadingData: false, plans: plans });
        };
        fetchData();
        return () => {
            requestToken.cancel('Operation canceled by the user.');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (createData?.plans?.length === 0) {
        createData.plans.push({ value: "plans_none", displayValue: "None" });
    }

    const handleSubmit = async data => {
        if (data["PlanID"] === "plans_none") {
            data["PlanID"] = null;
        }
        let result = await onCreateTrialVoucher({ ...data, ActiveCustomerID: activeCustomerID });
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {
        ExpiryDate: moment().add(1, 'month'),
        Description: '',
        PlanID: createData.plans && createData.plans.length > 0 ? createData.plans[0].value : '',
        NumberOfVouchers: '',
        Emails: ''
    };

    let formSettings = {
        Validation: {
            ExpiryDate: Yup.date().required("Required"),
            PlanID: Yup.string().required("Required"),
            NumberOfVouchers: Yup.number().required("Required"),
        },
        FormTitle: translations['create_trial_voucher'] || 'Create Trial Voucher',
        ButtonSubmit: {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        },
    };

    return !createData.loadingData ?
        <TrialVoucherForm
            formSettings={formSettings}
            initialValues={initialValues}
            handleSubmit={handleSubmit}
            plans={createData.plans}
            create={true}
            translations={translations}
        /> : <CircularProgress />;
}

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};
const mapDispatchToProps = dispatch => {
    return {
        onCreateTrialVoucher: data => dispatch(actions.createTrialVoucher(data)),
        onFetchPlans: (data, options) => dispatch(actions.fetchPlans(data, options))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TrialVoucherCreate);